"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.grade.title': '升级账户',
    'user.grade.free': '免费',
    'user.grade.basic': '基础',
    'user.grade.pro': '专业',
    'user.grade.ultra': '旗舰',
};
